import { ReactNode, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import type { FallbackProps } from "react-error-boundary";
import * as Sentry from "@sentry/react";

import InlineOops from "./InlineOops";

function FallbackComponent({ error }: FallbackProps) {
  useEffect(() => {
    if (!error) return;
    try {
      Sentry.captureException(error);
    } catch (e) {
      // pass, don't crash the crash screen if we can't use the crash reporter
    }
  }, [error]);

  return <InlineOops />;
}

export interface Props {
  children?: ReactNode;
}

export default function InlineErrorBoundary({ children }: Props) {
  return (
    <ErrorBoundary FallbackComponent={FallbackComponent}>
      {children}
    </ErrorBoundary>
  );
}
